"use strict";
function _typeof(t) {
  return (_typeof =
    "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
      ? function (t) {
          return typeof t;
        }
      : function (t) {
          return t &&
            "function" == typeof Symbol &&
            t.constructor === Symbol &&
            t !== Symbol.prototype
            ? "symbol"
            : typeof t;
        })(t);
}
function _createForOfIteratorHelper(t, e) {
  var i,
    r,
    n,
    o,
    s = ("undefined" != typeof Symbol && t[Symbol.iterator]) || t["@@iterator"];
  if (s)
    return (
      (r = !(i = !0)),
      {
        s: function () {
          s = s.call(t);
        },
        n: function () {
          var t = s.next();
          return (i = t.done), t;
        },
        e: function (t) {
          (r = !0), (n = t);
        },
        f: function () {
          try {
            i || null == s.return || s.return();
          } finally {
            if (r) throw n;
          }
        },
      }
    );
  if (
    Array.isArray(t) ||
    (s = _unsupportedIterableToArray(t)) ||
    (e && t && "number" == typeof t.length)
  )
    return (
      s && (t = s),
      (o = 0),
      {
        s: (e = function () {}),
        n: function () {
          return o >= t.length ? { done: !0 } : { done: !1, value: t[o++] };
        },
        e: function (t) {
          throw t;
        },
        f: e,
      }
    );
  throw new TypeError(
    "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
  );
}
function _unsupportedIterableToArray(t, e) {
  var i;
  if (t)
    return "string" == typeof t
      ? _arrayLikeToArray(t, e)
      : "Map" ===
          (i =
            "Object" === (i = Object.prototype.toString.call(t).slice(8, -1)) &&
            t.constructor
              ? t.constructor.name
              : i) || "Set" === i
      ? Array.from(t)
      : "Arguments" === i || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(i)
      ? _arrayLikeToArray(t, e)
      : void 0;
}
function _arrayLikeToArray(t, e) {
  (null == e || e > t.length) && (e = t.length);
  for (var i = 0, r = new Array(e); i < e; i++) r[i] = t[i];
  return r;
}
function _classCallCheck(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(t, e) {
  for (var i = 0; i < e.length; i++) {
    var r = e[i];
    (r.enumerable = r.enumerable || !1),
      (r.configurable = !0),
      "value" in r && (r.writable = !0),
      Object.defineProperty(t, _toPropertyKey(r.key), r);
  }
}
function _createClass(t, e, i) {
  return (
    e && _defineProperties(t.prototype, e),
    i && _defineProperties(t, i),
    Object.defineProperty(t, "prototype", { writable: !1 }),
    t
  );
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e)
    throw new TypeError("Super expression must either be null or a function");
  (t.prototype = Object.create(e && e.prototype, {
    constructor: { value: t, writable: !0, configurable: !0 },
  })),
    Object.defineProperty(t, "prototype", { writable: !1 }),
    e && _setPrototypeOf(t, e);
}
function _createSuper(i) {
  var r = _isNativeReflectConstruct();
  return function () {
    var t,
      e = _getPrototypeOf(i);
    return _possibleConstructorReturn(
      this,
      r
        ? ((t = _getPrototypeOf(this).constructor),
          Reflect.construct(e, arguments, t))
        : e.apply(this, arguments)
    );
  };
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" === _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e)
    throw new TypeError(
      "Derived constructors may only return object or undefined"
    );
  return _assertThisInitialized(t);
}
function _assertThisInitialized(t) {
  if (void 0 === t)
    throw new ReferenceError(
      "this hasn't been initialised - super() hasn't been called"
    );
  return t;
}
function _wrapNativeSuper(t) {
  var i = "function" == typeof Map ? new Map() : void 0;
  return (_wrapNativeSuper = function (t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t)
      throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== i) {
      if (i.has(t)) return i.get(t);
      i.set(t, e);
    }
    function e() {
      return _construct(t, arguments, _getPrototypeOf(this).constructor);
    }
    return (
      (e.prototype = Object.create(t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0,
        },
      })),
      _setPrototypeOf(e, t)
    );
  })(t);
}
function _construct(t, e, i) {
  return (_construct = _isNativeReflectConstruct()
    ? Reflect.construct.bind()
    : function (t, e, i) {
        var r = [null];
        r.push.apply(r, e);
        e = new (Function.bind.apply(t, r))();
        return i && _setPrototypeOf(e, i.prototype), e;
      }).apply(null, arguments);
}
function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;
  try {
    return (
      Boolean.prototype.valueOf.call(
        Reflect.construct(Boolean, [], function () {})
      ),
      !0
    );
  } catch (t) {
    return !1;
  }
}
function _isNativeFunction(e) {
  try {
    return -1 !== Function.toString.call(e).indexOf("[native code]");
  } catch (t) {
    return "function" == typeof e;
  }
}
function _setPrototypeOf(t, e) {
  return (_setPrototypeOf = Object.setPrototypeOf
    ? Object.setPrototypeOf.bind()
    : function (t, e) {
        return (t.__proto__ = e), t;
      })(t, e);
}
function _getPrototypeOf(t) {
  return (_getPrototypeOf = Object.setPrototypeOf
    ? Object.getPrototypeOf.bind()
    : function (t) {
        return t.__proto__ || Object.getPrototypeOf(t);
      })(t);
}
function _defineProperty(t, e, i) {
  return (
    (e = _toPropertyKey(e)) in t
      ? Object.defineProperty(t, e, {
          value: i,
          enumerable: !0,
          configurable: !0,
          writable: !0,
        })
      : (t[e] = i),
    t
  );
}
function _toPropertyKey(t) {
  t = _toPrimitive(t, "string");
  return "symbol" === _typeof(t) ? t : String(t);
}
function _toPrimitive(t, e) {
  if ("object" !== _typeof(t) || null === t) return t;
  var i = t[Symbol.toPrimitive];
  if (void 0 === i) return ("string" === e ? String : Number)(t);
  i = i.call(t, e || "default");
  if ("object" !== _typeof(i)) return i;
  throw new TypeError("@@toPrimitive must return a primitive value.");
}
!(function r(n, o, s) {
  function a(e, t) {
    if (!o[e]) {
      if (!n[e]) {
        var i = "function" == typeof require && require;
        if (!t && i) return i(e, !0);
        if (u) return u(e, !0);
        throw (
          (((t = new Error("Cannot find module '" + e + "'")).code =
            "MODULE_NOT_FOUND"),
          t)
        );
      }
      (i = o[e] = { exports: {} }),
        n[e][0].call(
          i.exports,
          function (t) {
            return a(n[e][1][t] || t);
          },
          i,
          i.exports,
          r,
          n,
          o,
          s
        );
    }
    return o[e].exports;
  }
  for (
    var u = "function" == typeof require && require, t = 0;
    t < s.length;
    t++
  )
    a(s[t]);
  return a;
})(
  {
    1: [
      function (t, e, i) {
        customElements.get("c-product-card") ||
          customElements.define(
            "c-product-card",
            (function () {
              _inherits(e, _wrapNativeSuper(HTMLElement));
              var t = _createSuper(e);
              function e() {
                var i;
                return (
                  _classCallCheck(this, e),
                  _defineProperty(
                    _assertThisInitialized((i = t.call(this))),
                    "initSlider",
                    function () {
                      var t = {
                        slidesPerView: 1,
                        speed: 500,
                        loop: !1,
                        grabCursor: !0,
                        pagination: !0,
                        navigation: !0,
                        scrollbar: !0,
                        breakpoints: { 768: {} },
                        on: {
                          init: i.updateCellsOnDifferentSize,
                          breakpoint: i.updateCellsOnDifferentSize,
                        },
                      };
                      Object.assign(i.sliderElement, t),
                        setTimeout(function () {
                          i.sliderElement.initialize();
                        }, 0);
                    }
                  ),
                  _defineProperty(
                    _assertThisInitialized(i),
                    "updateCellsOnDifferentSize",
                    function (t) {
                      if (767 < window.innerWidth) {
                        if (t.slides.length < i.initialSizeOfSlides) return;
                        t.removeSlide(0), t.updateSlides(), t.update();
                      } else {
                        if (t.slides.length >= i.initialSizeOfSlides) return;
                        t.prependSlide(i.firstSlide), t.slideTo(0, 0);
                      }
                      1 === t.slides.length &&
                        i.classList.add("hide-pagination");
                    }
                  ),
                  _defineProperty(
                    _assertThisInitialized(i),
                    "calculateHeight",
                    function () {
                      767 < window.innerWidth
                        ? (i.style.height = "".concat(
                            1.4907 * i.offsetWidth,
                            "px"
                          ))
                        : (i.style.height = "".concat(
                            1.6142 * i.offsetWidth,
                            "px"
                          ));
                    }
                  ),
                  _defineProperty(
                    _assertThisInitialized(i),
                    "handleMobileClick",
                    function (t) {
                      var e;
                      !i.classList.contains("is-active-mobile") &&
                        window.innerWidth < 768 &&
                        ((e = document.querySelector(
                          ".js-product-card.is-active-mobile"
                        )) && e.classList.remove("is-active-mobile"),
                        t.stopPropagation(),
                        i.classList.add("is-active-mobile"),
                        document.addEventListener(
                          "click",
                          i.documentOutsideClick
                        ));
                    }
                  ),
                  _defineProperty(
                    _assertThisInitialized(i),
                    "documentOutsideClick",
                    function (t) {
                      var e = document.querySelector(
                        ".js-product-card.is-active-mobile"
                      );
                      (null != e &&
                        e.contains(null == t ? void 0 : t.target)) ||
                        (null != e && e.classList.remove("is-active-mobile"),
                        document.removeEventListener(
                          "click",
                          i.documentOutsideClick
                        ));
                    }
                  ),
                  _defineProperty(
                    _assertThisInitialized(i),
                    "updateWishlistButton",
                    function () {
                      i.inWishlist
                        ? i.wishlistButton.classList.add("is-active")
                        : i.wishlistButton.classList.remove("is-active");
                    }
                  ),
                  _defineProperty(
                    _assertThisInitialized(i),
                    "wishlistButtonClickHandler",
                    function (t) {
                      t.preventDefault(),
                        t.stopPropagation(),
                        t.stopImmediatePropagation(),
                        window.SwymCallbacks || (window.SwymCallbacks = []),
                        i.inWishlist
                          ? window.SwymCallbacks.push(i.removeFromWishlist)
                          : window.SwymCallbacks.push(i.addToWishlist);
                    }
                  ),
                  _defineProperty(
                    _assertThisInitialized(i),
                    "addToWishlist",
                    function (t) {
                      var e = {
                        epi: i.dataset.variantId,
                        empi: i.dataset.productId,
                        du: i.dataset.productUrl,
                      };
                      t.addToList(
                        window.apps.wishlist.listId,
                        e,
                        function (t) {
                          (i.inWishlist = !0),
                            i.updateWishlistButton(),
                            window.PubSub.publish("wishlist-add-product", e),
                            "true" === i.dataset.openWishlist &&
                              window.PubSub.publish("open-wishlist-drawer");
                        },
                        function (t) {
                          console.error(
                            "Error while adding the Product to the List",
                            t
                          ),
                            i.wishlistButton.classList.remove("is-active");
                        }
                      );
                    }
                  ),
                  _defineProperty(
                    _assertThisInitialized(i),
                    "removeFromWishlist",
                    function (t) {
                      var e = {
                        epi: i.dataset.variantId,
                        empi: i.dataset.productId,
                        du: i.dataset.productUrl,
                      };
                      t.deleteFromList(
                        window.apps.wishlist.listId,
                        e,
                        function (t) {
                          (i.inWishlist = !1),
                            i.updateWishlistButton(),
                            window.PubSub.publish("wishlist-remove-product", e);
                        },
                        function (t) {
                          console.error("Error while deleting the Product", t);
                        }
                      );
                    }
                  ),
                  i
                );
              }
              return (
                _createClass(e, [
                  {
                    key: "connectedCallback",
                    value: function () {
                      var n = this;
                      (this.cardLink = this.querySelector(
                        ".js-product-card__image-wrapper"
                      )),
                        (this.inWishlist = !1),
                        (this.sliderElement =
                          this.querySelector("swiper-container")),
                        (this.wishlistButton = this.querySelector(
                          ".js-product-card__wishlist-button"
                        )),
                        this.cardLink.addEventListener(
                          "click",
                          this.handleMobileClick
                        ),
                        this.wishlistButton.addEventListener(
                          "click",
                          this.wishlistButtonClickHandler
                        ),
                        (this.wishlistLoadedUnsubscriber =
                          window.PubSub.subscribe(
                            "wishlist-loaded",
                            function (t) {
                              var e,
                                i = _createForOfIteratorHelper(t.listcontents);
                              try {
                                for (i.s(); !(e = i.n()).done; ) {
                                  var r = e.value;
                                  if (
                                    r.epi === n.dataset.variantId &&
                                    r.empi === n.dataset.productId
                                  ) {
                                    n.inWishlist = !0;
                                    break;
                                  }
                                }
                              } catch (t) {
                                i.e(t);
                              } finally {
                                i.f();
                              }
                              n.updateWishlistButton();
                            }
                          )),
                        (this.wishlistAddUnsubscriber = window.PubSub.subscribe(
                          "wishlist-add-product",
                          function (t) {
                            t.epi === n.dataset.variantId &&
                              t.empi === n.dataset.productId &&
                              ((n.inWishlist = !0), n.updateWishlistButton());
                          }
                        )),
                        (this.wishlistRemoveUnsubscriber =
                          window.PubSub.subscribe(
                            "wishlist-remove-product",
                            function (t) {
                              t.epi === n.dataset.variantId &&
                                t.empi === n.dataset.productId &&
                                ((n.inWishlist = !1), n.updateWishlistButton());
                            }
                          )),
                        this.updateWishlistButton(),
                        window.addEventListener(
                          "resize",
                          window.debounce(this.calculateHeight, 500)
                        ),
                        this.calculateHeight(),
                        this.sliderElement &&
                          ((this.initialSizeOfSlides =
                            +this.dataset.imagesLength),
                          (this.firstSlide = this.sliderElement.children[0]),
                          this.initSlider());
                    },
                  },
                  {
                    key: "disconnectedCallback",
                    value: function () {
                      window.removeEventListener(
                        "resize",
                        window.debounce(this.calculateHeight, 500)
                      ),
                        this.cardLink.removeEventListener(
                          "click",
                          this.handleMobileClick
                        ),
                        this.wishlistButton.removeEventListener(
                          "click",
                          this.wishlistButtonClickHandler
                        ),
                        this.wishlistLoadedUnsubscriber(),
                        this.wishlistAddUnsubscriber(),
                        this.wishlistRemoveUnsubscriber();
                    },
                  },
                ]),
                e
              );
            })()
          );
      },
      {},
    ],
  },
  {},
  [1]
);
